<div [formGroup]="form" class="form-group field" style="min-width: 180px" #opTarget>
  <p-float-label>
    <p-inputgroup class="w-full">
      <input
        type="text"
        pInputText
        [(ngModel)]="inputValue"
        [ngModelOptions]="{ standalone: true }"
        (blur)="onBlur($event)"
        [readOnly]="readonly"
      />
      @if (label) {
        <label for="dateControl" class="block"
          >{{ label }}
          @if (attribute?.displayNameSuffixIcon) {
            <i inline style="font-size: small">{{ attribute.displayNameSuffixIcon }}</i>
          }
          @if (isRequired()) {
            <span style="color: red">*</span>
          }
        </label>
      }
      @if (!readonly) {
        <p-inputgroup-addon>
          <p-button severity="secondary" (click)="clear($event)" [icon]="defaultIcon.Clear"></p-button>
        </p-inputgroup-addon>
      }
      <p-inputgroup-addon>
        <p-button
          severity="secondary"
          [value]="inputValue"
          [max]="maxDateString$ | async"
          [format]="timeFormat === '12' ? 12 : 24"
          [ngxTimepicker]="picker"
          [icon]="defaultIcon.Time"
        ></p-button>
      </p-inputgroup-addon>
      <ngx-material-timepicker #picker (timeSet)="onTimeSet($event)" [theme]="pickerTheme$ | async" />
      <!--
    [disableClick]="true"
    (click)="launchTimePicker()"
    -->
    </p-inputgroup>
  </p-float-label>
  <ng-content></ng-content>
  <div>
    @if (displayHint || attribute?.displayHint) {
      <small class="block">
        {{ displayHint ? displayHint : attribute?.displayHint }}
      </small>
    }
    <s-form-error-input
      [groupName]="groupName"
      [fieldName]="fieldName"
      [form]="form"
      [apiError]="apiError"
      [schema]="schema"
    />
  </div>
</div>
